import { Flex, Box, Button, useToast, Text, Badge } from '@chakra-ui/react';
import React from 'react';

import { useGetFinleyAiVirtualSheetSignedUrlsLazyQueryGQLType } from '../../requests/ai.gql.generated';
import { Icon } from 'packages/common-frontend/components/icons';
import {
  errorToastConfig,
  successToastConfig,
} from 'packages/common-frontend/constants';

export const DownloadContainer = ({
  finleyAiPromptResponseId,
}: {
  finleyAiPromptResponseId: string;
}) => {
  const toast = useToast();

  const [
    getDownloadLink,
    { loading: isSignedUrlLoading },
  ] = useGetFinleyAiVirtualSheetSignedUrlsLazyQueryGQLType({
    onError: () => {
      toast({
        ...errorToastConfig,
        title: `An error occurred while attempting to download the Excel file.`,
      });
    },
    onCompleted: ({ getSignedDownloadUrls }) => {
      if (getSignedDownloadUrls.length === 1) {
        const { url, filename } = getSignedDownloadUrls[0];

        // download
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        toast({
          ...successToastConfig,
          title: `Successfully downloaded ${filename}`,
        });
      } else {
        toast({
          ...errorToastConfig,
          title: `An error occurred while attempting to download the Excel file.`,
        });
      }
    },
    variables: {
      serializedParams: JSON.stringify({
        finleyAiPromptResponseId,
      }),
    },
    fetchPolicy: 'network-only',
  });

  return (
    <Box
      mt="24px"
      p="16px"
      borderRadius="md"
      border="1px solid"
      borderColor="blue.600"
    >
      <Flex align="center" mb="12px">
        <Badge colorScheme="blue" mr="8px">
          📥 Download Ready
        </Badge>
        <Text fontWeight="600" fontSize="md" color="blue.300">
          Generated Virtual Sheet
        </Text>
      </Flex>
      <Text fontSize="sm" color="gray.300" mb="16px">
        Your virtual sheet has been generated with the formulas and data you
        requested. Download the Excel file to view the results.
      </Text>
      <Flex justify="flex-start">
        <Button
          leftIcon={<Icon icon="download" />}
          colorScheme="blue"
          variant="solid"
          size="sm"
          onClick={() => getDownloadLink()}
          isLoading={isSignedUrlLoading}
          loadingText="Preparing download..."
        >
          Download Excel File
        </Button>
      </Flex>
    </Box>
  );
};
